import { Component, Input, OnInit } from '@angular/core';
import { Incidents } from 'src/app/model/installation/incidents.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-incidents-list',
  templateUrl: './installation-incidents-list.component.html',
  styleUrls: ['./installation-incidents-list.component.scss']
})
export class InstallationIncidentsListComponent implements OnInit {

  @Input() installation: any;
  constructor(private service: InstallationsService) { }

  public pannes !: Incidents
  public p: any = 0;
  public tJour = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  public tMois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  public breakdownSolver !: any;


  ngOnInit(): void {
    if (this.installation) {
      this.getPannes();
    }
  }

  public pageChange(e: any) {
    this.p = e-1;
   this.getPannes()
  }

  public getPannes(){
    this.service.getPannesData(this.installation.id_installation, this.p).subscribe((pannes) => {
      pannes.installation_rg_pannes_headers.forEach(panne =>{
        if(panne.traite){this.service.getBreakdownsolver(panne.id_rg_panne).subscribe((solver) => {
          if(solver[0]){
            panne.solver = solver[0];
          }
            this.breakdownSolver = solver
        })
        }
      });
      this.pannes = pannes;
    });
  }

  /**
* Display date into human format
*/
  public convertDate(date: string): string {

    let newDate = Date.parse(date);
    let correctDate = new Date(newDate);
    let result = this.tJour[correctDate.getDay()] + ' ' + correctDate.getDate() + ' ' + this.tMois[(correctDate.getMonth())] + ' ' + correctDate.getFullYear() + ' à ' + correctDate.getHours() + ':' + this.getCorrectMinuteDisplay(correctDate);
    return result;

  }


  /**Enhance minutes display */
  public getCorrectMinuteDisplay(date: Date): any {
    if (date.getMinutes() < 10) return '0' + date.getMinutes();
    else return date.getMinutes();
  }

  public markAsDeal(id : number, traite : number){
    if(traite== 0 ){
    this.service.markAsDeal(id, 1)
      .subscribe((data) => {
        // console.log(data);
      });
      this.getPannes();
    }
  }


}
